module.exports = __webpack_public_path__ + "img/date.7654ac8f.svg";